var _rect, _rect2, _path, _path2, _rect3, _path3, _path4, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCgWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.833008,
    y: 15.9995,
    width: 8.45876,
    height: 7.99985,
    fill: "#FDFDFD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.29297,
    y: 7.99951,
    width: 8.45876,
    height: 7.99985,
    fill: "#FDFDFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.29297 7.99985L17.7517 0V7.99985L9.29297 7.99985Z",
    fill: "#FDFDFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7517 24L9.29297 16.0001L17.7517 16.0001L17.7517 24Z",
    fill: "#FDFDFD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.751,
    y: 15.9995,
    width: 8.45876,
    height: 7.99985,
    fill: "#FDFDFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2092 7.99902L34.668 15.9989L26.2092 15.9989L26.2092 7.99902Z",
    fill: "#FDFDFD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.668 16.0001L26.2092 24L26.2092 16.0001L34.668 16.0001Z",
    fill: "#FDFDFD"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 17.751,
    width: 8.45876,
    height: 7.99985,
    fill: "#FDFDFD"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCgWhite);
export default __webpack_public_path__ + "static/media/cg-white.ec9c0580dbf5fc65cdd131c54f3f3017.svg";
export { ForwardRef as ReactComponent };